import React from "react"
import autobind from "class-autobind"
import { INotificationDocument } from "../../models"
import NotificationIcon from "material-ui/svg-icons/social/notifications"
import { IconButton, Paper } from "material-ui"
import { grey50, grey100, grey200, blueGrey600, blueGrey700, deepOrangeA700, grey600 } from "material-ui/styles/colors"
import * as api from "../../api"
import AuthenticationStore from "../../stores/AuthenticationStore"
import * as timeHelper from "../../helpers/timeHelper"
import { browserHistory } from "react-router"
import strings from "../../localization/strings"
import ClearAllIcon from "material-ui/svg-icons/action/delete-forever"
import AppStateStore from "../../stores/AppStateStore"

interface IProps {

}
interface IState {
    openNotificationPopup: boolean,
    notifications: INotificationDocument[]
    unreadNotificationCount: number
}

export default class Notifications extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openNotificationPopup: false,
            notifications: [],
            unreadNotificationCount: 0,
        }
        autobind(this)
        this.getUnreadNotificationCount()
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside)
        AuthenticationStore.getLoggedInUser().NotificationSettings &&
            (
                (
                    AuthenticationStore.getLoggedInUser().NotificationSettings.ExceptionNotificationSettings &&
                    AuthenticationStore.getLoggedInUser().NotificationSettings.ExceptionNotificationSettings.length > 0
                ) ||
                (
                    AuthenticationStore.getLoggedInUser().NotificationSettings.ScheduleNotificationSettings &&
                    AuthenticationStore.getLoggedInUser().NotificationSettings.ScheduleNotificationSettings.length > 0
                )
            ) &&
            setInterval(this.getUnreadNotificationCount, 3600000)
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside)
    }

    getNotifications() {
        api.getNotifications(AuthenticationStore.getLoggedInUser().Id).then(res =>
            this.setState({ notifications: res.data })
        )
    }

    getUnreadNotificationCount() {
        api.getUnreadNotificationCount(AuthenticationStore.getLoggedInUser().Id).then(res =>
            this.setState({ unreadNotificationCount: res.data })
        )
    }

    handleNotificationPopup() {
        this.setState({ openNotificationPopup: !this.state.openNotificationPopup }, () => this.getNotifications())
    }

    handleClickOutside(e) {
        const notificationsElem = document.getElementById("NotificationsElem")
        notificationsElem && !notificationsElem.contains(e.target) &&
            this.setState({ openNotificationPopup: false })
    }

    render() {
        return (
            <div
                id="NotificationsElem"
                style={{ position: "relative" }}
            >
                <IconButton
                    onClick={this.handleNotificationPopup}
                    style={{ width: 35, height: 35, padding: 0 }}
                    iconStyle={{ width: 30, height: 30 }}
                >
                    <NotificationIcon color={grey100} />
                </IconButton>
                {this.state.unreadNotificationCount > 0 &&
                    <div
                        style={{
                            position: "absolute", top: -5, right: -8, paddingLeft: 5, paddingRight: 5, fontSize: 14, fontWeight: 500, minWidth: 12,
                            backgroundColor: deepOrangeA700, color: grey50, borderRadius: 10, textAlign: "center", zIndex: 100
                        }}
                        onClick={this.handleNotificationPopup}
                    >
                        {this.state.unreadNotificationCount}
                    </div>
                }
                {this.state.openNotificationPopup &&
                    <Paper style={{ position: "absolute", top: 35, right: 25, zIndex: 10, width: 400 }}>
                        <div style={{ borderBottom: "1px solid rgb(224, 224, 224)", padding: 15, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ fontSize: 18, fontWeight: 600 }}>
                                {strings.Notifications}
                            </div>
                            <IconButton
                                style={{ width: 25, height: 25, padding: 0, display: (!this.state.notifications || this.state.notifications.length === 0) && "none" }}
                                iconStyle={{ width: 24, height: 24, color: grey600 }}
                                onClick={() => AppStateStore.setConfirmDialogContent({
                                    content: strings.Are_you_sure_you_want_to_clear_all_notifications,
                                    confirm: async () => {
                                        await api.clearNotifications(AuthenticationStore.getLoggedInUser().Id)
                                        this.getUnreadNotificationCount()
                                        this.getNotifications()
                                    }
                                })}
                            >
                                <ClearAllIcon />
                            </IconButton>
                        </div>
                        <div style={{ overflowY: "auto", maxHeight: window.innerHeight - 150 }}>
                            {this.state.notifications.map((item, index) => [
                                <div
                                    key={index}
                                    style={{ backgroundColor: !item.Read && grey200, borderBottom: "1px solid rgb(224, 224, 224)", paddingLeft: 20, paddingRight: 20, paddingTop: 10, paddingBottom: 10, position: "relative" }}
                                    onClick={() =>
                                        !item.Read &&
                                        api.setReadNotification(item.Id).then(() => {
                                            this.getUnreadNotificationCount()
                                            const notifications = this.state.notifications
                                            notifications.forEach(notification => {
                                                if (item.Id === notification.Id)
                                                    item.Read = true
                                            })
                                            this.setState({ notifications })
                                        })
                                    }
                                >
                                    <div style={{ position: "absolute", top: 5, right: 10, color: blueGrey700, fontWeight: 500 }}>{timeHelper.getPassedDateTime(item.CreatedDate)}</div>
                                    <div
                                        className={item.ActionURL && "HoverUnderLine"}
                                        style={{ fontSize: 16, fontWeight: 600, color: blueGrey600 }}
                                        onClick={() => item.ActionURL && browserHistory.push(item.ActionURL)}
                                    >
                                        {item.Title}
                                    </div>
                                    <div style={{ marginTop: 10, whiteSpace: "break-spaces" }} dangerouslySetInnerHTML={{__html:item.Description}}></div>
                                </div>
                            ])}
                        </div>
                    </Paper>
                }
            </div>
        )
    }
}